import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// 註冊所需的 Chart.js 組件
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const UtilizationAnalysis = () => {
    const data = {
        labels: ['Warehouse A', 'Warehouse B', 'Warehouse C', 'Warehouse D'],
        datasets: [
            {
                label: '利用率 (%)',
                data: [75, 50, 90, 60],  // 每個倉庫的利用率
                backgroundColor: 'rgba(75, 192, 192, 0.5)',  // 水桶顏色
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    // 設定選項，使用 "indexAxis" 將X軸和Y軸對調來產生水桶效果
    const options = {
        indexAxis: 'y',  // 這會將X軸和Y軸對調，使柱狀圖水平排列
        scales: {
            x: {
                beginAtZero: true,  // 從0開始
                max: 100,  // 假設利用率最高是100%
            },
            y: {
                ticks: {
                    autoSkip: false,  // 保證顯示所有倉庫名稱
                },
            },
        },
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: '庫別利用率分析（%）',
            },
        },
    };

    return (
        <div className="p-4">
            <h2 className="text-2xl font-bold mb-4">庫別利用率分析</h2>
            <Bar data={data} options={options} />
        </div>
    );
};

export default UtilizationAnalysis;
